import { render, staticRenderFns } from "./settlementTask.vue?vue&type=template&id=5dbbf821&scoped=true"
import script from "./settlementTask.vue?vue&type=script&lang=js"
export * from "./settlementTask.vue?vue&type=script&lang=js"
import style0 from "./settlementTask.vue?vue&type=style&index=0&id=5dbbf821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbf821",
  null
  
)

export default component.exports